import {
  Circle as CircleStyle,
  Fill,
  Text,
  Stroke,
  Style,
  Icon,
} from "ol/style";
import MultiPoint from "ol/geom/MultiPoint.js";
import { defaultTextStyles, defaultCircleStyles } from "./default.styles";

import * as _ from "lodash";

const textObject = (props) => {
  const {
    textAlign,
    textBaseline,
    font,
    text,
    fill,
    stroke,
    offsetX,
    offsetY,
    background,
    padding,
  } = props;
  return new Text({
    textAlign,
    textBaseline: textBaseline,
    font: `${font.size}px ${font.name}`,
    text,
    fill: new Fill({ color: fill.color }),
    stroke: new Stroke({ color: stroke.color, width: stroke.width }),
    offsetX,
    offsetY,
    backgroundFill: background.fill.color
      ? new Fill({ color: background.fill.color })
      : null,
    backgroundStroke: background.stroke.color
      ? new Stroke({
          color: background.stroke.color,
          width: background.stroke.width,
        })
      : null,
    padding: padding,
  });
};

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function zoneStyleText(color, text) {
  const t = text !== "Zone_segment" ? text : `${text}`;
  // if(text){
  //
  // }
  return new Text({
    textAlign: "center",
    textBaseline: "middle",
    font: "lighter 14px Courier new",
    text: t,
    fill: new Fill({ color }),
    // stroke: new ol.style.Stroke({color: 'white', width: 1}),
    offsetX: 0,
    offsetY: 0,
    rotation: 0,
  });
}

export const poligonStyleWithPhrase = (name, color, highlight) => {
  function polygonZoneStyle(color, text, isHighlight) {
    let colorDraw = color;
    if (!colorDraw || colorDraw === "") {
      colorDraw = "#2ecc71";
    }
    const rgba = hexToRgb(colorDraw);
    let fill = `rgba(${rgba.r},${rgba.g},${rgba.b},0.1)`;

    if (isHighlight) {
      fill = `rgba(${rgba.r},${rgba.g},${rgba.b},0.4)`;
    }
    return new Style({
      fill: new Fill({
        color: fill,
      }),
      stroke: new Stroke({
        color,
        width: 1,
      }),
      text: zoneStyleText(color, text),
    });
  }
  const styleObj = [];

  styleObj.push(polygonZoneStyle(color, name, highlight));
  styleObj.push(
    new Style({
      image: new CircleStyle({
        radius: 4,
        fill: new Fill({
          color: "white",
        }),
        stroke: new Stroke({
          color,
          width: 2,
        }),
      }),
      geometry(feature) {
        // return the coordinates of the first ring of the polygon
        const coordinates = feature.getGeometry().getCoordinates()[0];
        return new MultiPoint(coordinates);
      },
    })
  );
  return styleObj;
};

export const clusterizedStyle = (size) => {
  const radius = 12 + (12 * size) / 8;
  return new Style({
    image: new CircleStyle({
      radius: 18,
      stroke: new Stroke({
        color: '#505050',
        width: 1.3
      }),
      fill: new Fill({
        color: 'white',
      }),
    }),
    text: new Text({
      text: size.toString() < 100 ? size.toString() : '99+' ,
      font: `17px Circe-Regular`,
      textAlign: "center",
      textBaseline: "middle",
      fill: new Fill({
        color: "#505050",
      }),
      padding: [0, 0, 0, 0],
    }),
  });
};

export const circeWithText = (options) => {
  const defaultStyles = {
    text: defaultTextStyles,
    circle: defaultCircleStyles,
  };

  let mergedStyles = _.merge({}, defaultStyles, options);

  return new Style({
    text: textObject(mergedStyles.text),
    image: new CircleStyle({
      radius: mergedStyles.circle.radius,
      fill: mergedStyles.circle.fill.color
        ? new Fill({
            color: mergedStyles.circle.fill.color,
          })
        : undefined,
      stroke: new Stroke({
        color: mergedStyles.circle.stroke.color,
        width: mergedStyles.circle.stroke.width,
      }),
    }),
  });
};

export const iconStyle = (options) => {
  const defaultImageStyles = {
    text: defaultTextStyles,
    image: {
      crossOrigin: "anonymous",
    },
  };

  let mergedStyles = _.merge({},defaultImageStyles, options);

  const imageStyles = new Style({
    text: textObject(mergedStyles.text),
    image: new Icon(mergedStyles.image),
  });

  return imageStyles;
};


export const trackLine = (color) => {
  return new Style({
    stroke: new Stroke({ color: color, width: 2.2 }),
  })
}